<span
  *ngFor="let discipline of smeDisciplines"
  class="adap-chip adap-chip-discipline"
  [matTooltip]="discipline | smeDisciplineChipTooltip | async"
  matTooltipPosition="above"
  matTooltipShowDelay="500"
>
  {{ discipline.disciplineCode }}
</span>
